function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}import * as React from 'react';
import styled from 'styled-components';

const Anchor = /*#__PURE__*/React.forwardRef(function Anchor(
inputProps,
ref)
{
  const { children, ...props } = inputProps;
  return /*#__PURE__*/(
    React.createElement("a", _extends({}, props, { ref: ref }),
    children));


});

const Button = /*#__PURE__*/React.forwardRef(function Button(
inputProps,
ref)
{
  const { children, ...props } = inputProps;
  return /*#__PURE__*/(
    React.createElement("button", _extends({}, props, { ref: ref }),
    children));


});







const ClickableView = ({
  component,
  children,
  clickableRef,
  ...rest }) =>
{
  let Component;





  if (component) {
    Component = component;
  } else {
    Component = rest.href ? Anchor : Button;
  }

  return /*#__PURE__*/(
    React.createElement(Component, _extends({}, rest, { ref: clickableRef }),
    children));


};

const Clickable = /*#__PURE__*/styled(ClickableView).withConfig({ displayName: "Clickable", componentId: "sc-1l3tw0d-0" })(["border:none;margin:0;padding:0;width:auto;overflow:visible;background:transparent;color:inherit;font:inherit;line-height:normal;-webkit-font-smoothing:inherit;-moz-osx-font-smoothing:inherit;appearance:none;text-align:inherit;&::-moz-focus-inner{border:0;padding:0;}"]);






















export default Clickable;